// src/UI/Text/BodyText.tsx
import React, { FC, ReactNode } from "react";
import Typography, { TypographyProps } from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

/**
 * Стилизованный компонент на базе MUI Typography.
 */
const StyledBodyText = styled(Typography)(({ theme }) => ({
  fontFamily: "Inter, sans-serif",
  fontSize: 16,
  lineHeight: "20px",
  color: theme.palette.TextAndIcon.primaryBlackBlueEnabled,
}));

/**
 * Интерфейс для пропсов компонента BodyText.
 * - variant?: тип заголовка (body1, body2, h6, etc.)
 * - children?: содержимое
 * - Остальные пропсы передадим MUI Typography
 */
interface BodyTextProps extends TypographyProps {
  children?: ReactNode;
}

/**
 * Компонент BodyText.
 * По умолчанию variant="body1", можно переопределять.
 */
const BodyText: FC<BodyTextProps> = ({
  children,
  variant = "body1",
  ...props
}) => {
  return (
    <StyledBodyText variant={variant} {...props}>
      {children}
    </StyledBodyText>
  );
};

export default BodyText;
